import { connect } from 'react-redux'
import {
  compose, lifecycle, withState, withHandlers,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration, updateSiteConfigs } from 'actions/Site'
import { fetchHighlight, deleteHighlight } from 'actions/HighlightSimpan'
import HighlightSimpanView from 'components/pages/webManagement/highlightSimpan/List'
import { message } from 'antd'

export function mapStateToProps(state) {
  const { currentUser } = state.root.auth

  return {
    currentUser,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchHighlight: bindActionCreators(fetchHighlight, dispatch),
  deleteHighlight: bindActionCreators(deleteHighlight, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('highlightList', 'setHighlight', {
    data: [],
    meta: {},
    isFetching: true,
  }),
  withHandlers({
    getHighlightList: props => () => {
      props.fetchHighlight()
        .then((result) => {
          props.setHighlight({
            data: result.data,
            meta: result.meta,
            isFetching: false,
          })
        })
        .catch((error) => {
          props.setHighlight({
            data: [],
            meta: {},
            isFetching: false,
          })
          message.error(error.message)
        })
    },
  }),
  withHandlers({
    handleDelete: props => (id) => {
      props.deleteHighlight(id)
        .then(() => {
          props.getHighlightList()
        })
        .catch((error) => { message.error(error) })
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Web Management', 'Highlight Simpan'])
      this.props.updateSiteConfigs({
        titlePage: 'Highlight List',
        activePage: 'web-management/highlight-simpan',
        activeSubPage: 'web-management',
      })
      this.props.getHighlightList()
    },
  }),
)(HighlightSimpanView)
